<template>
  <div class="h-full p-2.5">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      class="grid h-full gap-x-3 overflow-hidden px-2.5"
      style="grid-template-columns: 1fr 0.8fr"
    >
      <div class="flex flex-col overflow-y-auto pr-2">
        <el-form-item
          label="公司简介"
          prop="content"
          :rules="[
            { required: true, message: '请输入公司简介', trigger: 'blur' },
          ]"
        >
          <c_editor
            @change="
              (value) => {
                state.model.content = value;
              }
            "
            class="flex flex-col h-full"
            :value="state.model.content"
          ></c_editor>
          <!-- <el-input
            v-model="state.model.description"
            type="textarea"
            :autosize="{ minRows: 8 }"
          ></el-input> -->
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="phone"
          :rules="[
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <el-form-item
          prop="address"
          :rules="[{ required: true, message: '请选择地址', trigger: 'blur' }]"
        >
          <template #label>
            <div class="float-right flex items-center">
              <text>公司地址</text>
              <text class="ml-3 text-orange-500 text-xs"
                >请在右侧地上图通过鼠标左键标记公司的详细地理位置坐标</text
              >
            </div>
          </template>
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
      </div>
      <div class="flex flex-col">
        <c_map
          class="flex-1"
          :point="[state.model?.longitude, state.model?.latitude]"
          @setAddress="
            (item) => {
              if (!state.model.province) {
                state.model.province = item.province;
                state.model.city = item.city;
                state.model.district = item.district;
              }
              state.model.longitude = item.longitude;
              state.model.latitude = item.latitude;

              state.model.address = item.address;
              state.model.area = [item.province, item.city, item.district];
            }
          "
        />
        <el-button
          type="primary"
          class="w-full mt-2"
          size="large"
          @click="onSubmit"
        >
          提交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_website_about_meetingInfo,
  meeting_website_about_meetingInfoSave,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.meeting_id) {
        meeting_website_about_meetingInfo(props.meeting_id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
          }
        });
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.area?.length == 3) {
            state.model.province = state.model.area[0];
            state.model.city = state.model.area[1];
            state.model.district = state.model.area[2];
          }

          meeting_website_about_meetingInfoSave(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("refresh");
              }, 500);
            });
          });
        }
      });
    };
    return { state, formDom, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
